import Loading from 'elements/AppLoading';

export default Loading;
